<template>
    <div class="r3-cont">
        <div class="r3-item" v-for="(item, i) in 2">
            <div class="item-head">
                <div class="item-val">{{ defaultdata[i].value2 }}</div>
                <div class="item-unit">{{ defaultdata[i].value3 }}</div>
            </div>
            <div class="item-name">{{ defaultdata[i].value1 }}</div>
        </div>
    </div>
</template>

<script>
import * as methods from "./method.js";
export default {
    name: "template.scope129",
    props: {
        vdata: {
            type: [Array, String],
            default: () => [],
        },
        jsondata: {
            type: [Array, String],
            default: () => [],
        },
        scopedata: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            defaultdata: [
                { value1: '数据一', value2: '000', value3: '单位' },
                { value1: '数据二', value2: '000', value3: '单位' },
            ],
            valueMap: [
                { name: "名称", key: "value1" },
                { name: "数值", key: "value2" },
                { name: "单位", key: "value3" },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
        }
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
                let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
            }
        },
        jsondata(n) {
            this.exceldata = n;
        },
        defaultdata(n) {
        },
    },
    methods: {
        ...methods
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata;
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata;
        }
        this.setData()
    },
}
</script>

<style scoped lang="scss">
.r3-cont {
    width: 435px;
    height: 240px;
    padding: 10px 0;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .r3-item {
        width: 188px;
        height: 217px;
        background: url(@/assets/temimg4/yq-dz2.png) no-repeat;
        background-size: 100% 100%;
        &:first-child {
            background: url(@/assets/temimg4/yq-dz1.png) no-repeat;
            background-size: 100% 100%;
        }
    }
    .item-head {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        margin-top: 12px;
        .item-val {
            font-family: PingFang SC;
            font-weight: 600;
            font-size: 27px;
            color: #FEFFFF;
            white-space: nowrap;
            max-width: 158px;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .item-unit {
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #A0B5C1;
            padding-bottom: 4px;
            white-space: nowrap;
            max-width: 30px;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    .item-name {
        text-align: center;
        margin-top: 70px;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #A0B5C1;
        white-space: nowrap;
        max-width: 188px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>